import type {
  EntryTemplate,
  AccountInsulin as ApiAccountInsulin,
  AccountMedication as ApiAccountMedication,
  Insulin as ApiInsulin,
  Medication as ApiMedication,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useAccountInsulinLoader,
  useAccountMedicationLoader,
  useInsulinLoader,
  useMedicationLoader,
  useEntryTemplateLoader,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { createSimpleLoadingContextProvider } from "./createSimpleLoadingContextProvider"
import { transformAccountInsulin } from "src/hooks/accountInsulin/transformAccountInsulin"
import { transformAccountMedication } from "src/hooks/accountMedication/transformAccountMedication"
import { transformInsulin } from "src/hooks/insulin/transformInsulin"
import { transformMedication } from "src/hooks/medication/transformMedication"
import {
  CollectionKey,
  UserLocalStorageKey,
} from "src/types"
import type {
  AccountInsulin,
  AccountMedication,
  Insulin,
  Medication,
} from "src/types"

export const [
  InsulinLoadingProvider,
  useInsulinLoading,
  useInsulinReloading,
] = createSimpleLoadingContextProvider<ApiInsulin, Insulin>({
  collectionKey: CollectionKey.Insulin,
  localStorageKey: UserLocalStorageKey.InsulinsLoadedBefore,
  useLoader: useInsulinLoader,
  transform: transformInsulin,
})

export const [
  AccountInsulinLoadingProvider,
  useAccountInsulinLoading,
  useAccountInsulinReloading,
] = createSimpleLoadingContextProvider<ApiAccountInsulin, AccountInsulin>({
  collectionKey: CollectionKey.AccountInsulin,
  localStorageKey: UserLocalStorageKey.AccountInsulinsLoadedBefore,
  useLoader: useAccountInsulinLoader,
  transform: transformAccountInsulin,
})

export const [
  MedicationLoadingProvider,
  useMedicationLoading,
  useMedicationReloading,
] = createSimpleLoadingContextProvider<ApiMedication, Medication>({
  collectionKey: CollectionKey.Medication,
  localStorageKey: UserLocalStorageKey.MedicationsLoadedBefore,
  useLoader: useMedicationLoader,
  transform: transformMedication,
})

export const [
  AccountMedicationLoadingProvider,
  useAccountMedicationLoading,
  useAccountMedicationReloading,
] = createSimpleLoadingContextProvider<ApiAccountMedication, AccountMedication>({
  collectionKey: CollectionKey.AccountMedication,
  localStorageKey: UserLocalStorageKey.AccountMedicationsLoadedBefore,
  useLoader: useAccountMedicationLoader,
  transform: transformAccountMedication,
})

export const [
  EntryTemplateLoadingProvider,
  useEntryTemplateLoading,
  useEntryTemplateReloading,
] = createSimpleLoadingContextProvider<EntryTemplate>({
  collectionKey: CollectionKey.EntryTemplate,
  localStorageKey: UserLocalStorageKey.EntryTemplatesLoadedBefore,
  useLoader: useEntryTemplateLoader,
  transform: (i) => i,
})
